
































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import requestService from "@/service/requestService";
import { ShakenShohiyou, Item } from "@/model/ShakenShohiyou";
import { Getter, Action } from "vuex-class";
import Number from "@/shared/filters/Number";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Utils } from "@/service/util";
import { UserService } from "@/service/UserService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { ElForm } from "element-ui/types/form";
import { ElButton } from "element-ui/types/button";
import InputNumber from "@/components/common/input/InputNumber.vue";
import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import UserFooter from "@/components/UserFooter.vue";
import { RyoukinRank, Hikazei3, HikazeiRyoukin } from "@/model/RyoukinRank";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { ShakenStorage } from "@/service/storage";

@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    JibaiseikiDialog,
    JuuryouzeiDialog,
    UserFooter,
    TopBarTitle
  }
})
export default class InspectionCostPage extends Vue {
  isModeModal: boolean = false;
  isModeQuick: boolean = false;
  isEditPrice: boolean = false;
  isEditPriceNex: number = -1;
  showAside: boolean = true;
  updating: boolean = false;
  currentTab: number = 1;
  reqService: requestService;
  ippanSeibiService: IppanSeibiService;
  isChangeShohiyou: boolean = false;
  // costData: ShakenShohiyou = {
  //   houteiHiyou: {},
  //   kensaHiyou: {},
  //   shakenHiyou: {}
  // };
  totalcostData: ShakenShohiyou = {} as ShakenShohiyou;
  isZenuki: boolean = false;
  // loading: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMsg: string = "";
  displayDialogTax: boolean = false;
  displayDialogShouhiyou: boolean = false;
  // commonAPI の自賠責保険料表。選択済みの区分・金額の照合にも利用する。
  jibaiseikiTable: any[] = [];
  jibaiseikiNewFlg: number = 0;
  jibaiseikiLabel: string = "";
  jibaiseikiDisplayLimit: string = "";
  juuryouzeiKubun: any = null;
  isSetFormData: boolean = false;
  formData: JuuryouzeiJibaiseikiSave = {
    zeiJibaisekiMonthCnt: null,
    zkJibaisekiCd: null,
    zeiJibaisekiZn: null,
    zeiJibaisekiZk: null,
    zkWeightTaxCd: null,
    zeiWeightTax: null,
    sknTaxWeightRequestResultId: null,
    zeiInshidaiZn: null,
    zeiInshidaiZk: null,
    zeiInshidaiGenka: null,
    ryoukinRankCd: null,
    isMadoguchiInshidai: 0,
    isUseTechInfoAmount: 0,
    zeiTechInfoAmountZn: null,
    zeiTechInfoAmountZk: null
  };
  listRyoukinRank: HikazeiRyoukin = { hikazei3: [], ryoukinRank: [] };
  ryoukinRankSelected: any = null;
  hikazei3KingakuSelected: any = null;
  shakenBaseHiyouList: any = [];
  shakenHiyouListKazei: any = [];
  shakenHiyouListHikazei: any = [];
  isClearFromButton: boolean = false;
  isEditKensaHiyou: boolean = false;
  isEditKensaHiyouNex: boolean = false;

  isMadoguchiInshidaiChecked: boolean = false;
  inshidaiMadoguchi: number = 1200;

  confirmDialogTaxWeightMsg: string = "";
  loading: boolean = false;
  zeiWeightTaxStaging: number = 0;
  taxWeightResultStaging: any = null;
  appliedTaxWeightResult: any = null;
  taxWeightOutsideHours: boolean = false;
  taxWeightHoursLoading: boolean = false;
  taxWeightHoursStart: string = "";
  taxWeightHoursEnd: string = "";
  taxWeightHoursTimer: any = null;
  taxWeightHoursRequest: number = 0;
  taxWeightRequestDate: string = "";
  taxWeightDateOptions = {
    disabledDate: (date: Date) => !this.isTaxWeightDateValid(moment(date).format("YYYY/MM/DD"))
  };

  /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
  isInshidaiZero: boolean = false;
  /** 2021-12-23 sh #7620 allows to set zero yen. [END] */

  public utils: Utils = new Utils();

  rules = {
    zeiJibaisekiZk: [{ validator: this.validatejibaiseiki, trigger: "blur" }],
    zeiJibaisekiMonthCnt: [
      { validator: this.validatejibaiseikiMonth, trigger: "blur" }
    ],
    zeiWeightTax: [{ validator: this.validatejuuryouzei, trigger: "blur" }],
    zeiInshidaiZn: [{ validator: this.validateInshidai }],
    ryoukinRankCd: [{ validator: this.validateRyoukinRank }]
  };
  userService: UserService;

  $refs!: {
    errorDialog: ConfirmDialog;
    taxForm: ElForm;
    jibaiseikiDialog: JibaiseikiDialog;
    juuryouzeiDialog: JuuryouzeiDialog;
    btnConfirmTax: ElButton;
    inputKingaku: InputNumber[];
    confirmDialogTaxWeight: ConfirmDialog;
    confirmDialogTaxWeightErr: ConfirmDialog;
  };

  @Action("updateShakenHiyou", { namespace: "Shohiyou" })
  updateShakenHiyou: any;
  @Action("confirm", { namespace: "Shohiyou" })
  confirm: any;

  @Getter("hasData", { namespace: "Shohiyou" })
  hasData: boolean;
  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Action("updateRyoukinRankCd", { namespace: "ReservationDetail" })
  updateRyoukinRankCd: any;

  @Action("setEnvironment", { namespace: "Environment" })
  setEnvironment: any;
  @Getter("environment", { namespace: "Environment" })
  environment: any;

  @Getter("shohiyouLoading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("shohiyouError", { namespace: "UserDataState" })
  shohiyouError: string;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;

  @Action("updateTax", { namespace: "Shohiyou" })
  updateTax: any;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-14 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-14 nextage [END] */

  get isError() {
    return this.shohiyouError != "";
  }

  onCloseError() {
    this.setError({ key: "shohiyou", value: "" });
  }

  created() {
    this.reqService = new requestService();
    this.userService = new UserService();
    this.ippanSeibiService = new IppanSeibiService();
    const authContext = ShakenStorage.getActiveAuth("user");
    const kyoten = authContext && authContext.kyotenCd;
    if (this.environment == null && kyoten) {
      this.reqService.getEnvironment(kyoten).then((env: any) => {
        this.setEnvironment(env);
      });
    }

    this.getInspectionCostApi();
    if (window.sessionStorage.getItem("shaken:v2:user:shouhiyou-edit-mode")) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("shaken:v2:user:shouhiyou-edit-mode");
    }
  }

  mounted() {
    this.userService.getShohiyou(); // 同期漏れがあるので画面表示で最新データをロード
    this.$emit("onActiveSideTab", "inspectioncost");
    if (this.shakenHiyouListKazei.length === 0 || this.shakenHiyouListHikazei.length === 0) {
      this.onKensaHiyouChange();
      this.onShakenHiyouChange();
    }
  }

  onClickEdit(isEdit: boolean) {
    this.isEditPrice = isEdit;
    if (!this.isEditPrice && this.isChangeShohiyou) {
      this.onConfirm(0);
    }
  }

  @Watch("costData.kensaHiyou.items")
  onKensaHiyouChange() {
    if (this.costData.kensaHiyou.items) {
      this.shakenBaseHiyouList = this.costData.kensaHiyou.items;
    }
  }

  @Watch("costData.shakenHiyou.items")
  onShakenHiyouChange() {
    if (this.costData.shakenHiyou.items) {
      // ネクステージ版では課税区分で分岐。通常は全部課税用のエリアに表示する
      this.shakenHiyouListKazei = this.costData.shakenHiyou.items.filter((data: any) => {
        return data.shohiyouNm != '' && ( !this.isNextageCustom || ( this.isNextageCustom && data.kazeiKbn == '1' ) );
      });
      this.shakenHiyouListHikazei = this.costData.shakenHiyou.items.filter((data: any) => {
        return data.shohiyouNm != '' && this.isNextageCustom && data.kazeiKbn == '2';
      });
      // this.shakenHiyouListKazei = this.costData.shakenHiyou.items.filter(
      // (data: any) => data.shohiyouNm != '' && data.kazeiKbn == '1');
      // this.shakenHiyouListHikazei = this.costData.shakenHiyou.items.filter(
      // (data: any) => data.shohiyouNm != '' && data.kazeiKbn == '2');
    }
  }

  onClickEditNex(no: number) {
    if ( this.isEditPriceNex == -1 ) {
      this.isEditPriceNex = no;
    } else {
      if (this.isChangeShohiyou) {
        this.onConfirm(0);
      }
      if ( this.isEditPriceNex == no ) {
        this.isEditPriceNex = -1;
        this.displayDialogShouhiyou = false;
      } else {
        this.isEditPriceNex = no;
      }
    }
  }

  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [START] */
  onConfirm(isConfirm: number) {
    let kingakuZn0 = 0;
    let kingakuZk0 = 0;
    let data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      isHikazei: this.costData.kensaHiyou.isHikazei, // 2021-08-23 sh #7361 fix bug. it does not update kensaHiyou.
      subTotalZn: this.costData.kensaHiyou.subTotalZn ? this.costData.kensaHiyou.subTotalZn: 0,
      subTotalZk: this.costData.kensaHiyou.subTotalZk ? this.costData.kensaHiyou.subTotalZk: 0,
      subKingakuZn2: 0,
      subKingakuZk2: 0
    };

    // 2番目のみ編集できるので追加送信
    // 基本車検費用の2項目の合算値を車検基本費用として格納する
    // 同時送信してAPI通信を1回で片づける
    if (this.shakenBaseHiyouList.length > 0) {
      kingakuZn0 = this.shakenBaseHiyouList[0].kingakuZn;
      kingakuZk0 = this.shakenBaseHiyouList[0].kingakuZk;
    }
    if (this.shakenBaseHiyouList.length > 1) {
      data.subTotalZn = kingakuZn0 + this.shakenBaseHiyouList[1].kingakuZn;
      data.subTotalZk = kingakuZk0 + this.shakenBaseHiyouList[1].kingakuZk;
      data.subKingakuZn2 = this.shakenBaseHiyouList[1].kingakuZn;
      data.subKingakuZk2 = this.shakenBaseHiyouList[1].kingakuZk;
    }

    let promise = this.updateKensaHiyouPM(data);
    this.$set(this, "updating", true);
    Promise.all([promise]).then(() => {
      this._onConfirm(isConfirm);
      this.$set(this, "updating", false);
    });
  }
  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [END] */

  _onConfirm(isConfirm: number) {
    let isConfirmCopied: any = isConfirm;
    if (isConfirm == 0) {
      isConfirmCopied = this.costData.isConfirm;
    }
    this.confirm(isConfirmCopied);
    let data = {
      isHikazei: 0, // this.costData.isHikazei, 2021-08-23 sh ひとまず、すべて課税で処理をする。（課税、非課税の切替に未対応のため）
      shakenHiyous: this.costData.shakenHiyou.items,
      sknUketsukeUserJouhou: {
        isConfirmHiyou: isConfirmCopied
      },
      sknUketsukeExtendsId: this.uketsukeExtendsId
    };
    this.$set(this, "updating", true);
    this.reqService.saveShohiyou(data).then( // sendSocket:15車検諸費用の編集
      (res: any) => {
        this.isChangeShohiyou = false;
        this.$set(this, "updating", false);
        this.updateShakenHiyou(res);
        this.$emit("onUserConfirm");
        if (isConfirm == 1 && this.isNextageCustom) {
          this.$router.push({ name: "discountcoupon" });
        } else if (isConfirm == 1) {
          this.$router.push({ name: "option" });
        }
      },
      (error: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  onSave() {
    this.onConfirm(0);
  }

  getInspectionCostApi() {
    if (!this.hasData && !this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
      // get data from api
      // this.reqService.getInsectionCost(this.uketsukeExtendsId).then(
      //   (response: any) => {
      //     if (response) {
      //       this.loading = false;
      //       const { totalZn, totalZk, isHikazei, isConfirm } = response;
      //       this.setShakenShohiyou(response);
      //       this.$set(this, "costData", { ...response });
      //       this.$set(this, "totalcostData", {
      //         totalZn,
      //         totalZk,
      //         isHikazei,
      //         isConfirm
      //       });
      //     }
      //   },
      //   (err: any) => {
      //     this.loading = false;
      //     this.onError(err);
      //   }
      // );
    }
  }

  onError(res: any) {
    this.errorMsg = this.utils.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  // getJibaisekiKiIsAddMonth() {
  //   if (this.environment == null) {
  //     const kyoten = window.localStorage.getItem("kyotenCd");
  //     if (kyoten) {
  //       this.reqService.getEnvironment(kyoten).then((env: any) => {
  //         this.setEnvironment(env);
  //         return Promise.resolve(env.jibaisekiKikanIkkagetsuKasan);
  //       });
  //     }
  //   } else {
  //     return Promise.resolve(this.environment.jibaisekiKikanIkkagetsuKasan);
  //   }
  //   return Promise.resolve(0);
  // }

  get zeiJibaisekiMonthCnt() {
    if (
      this.costData.houteiHiyou &&
      this.costData.houteiHiyou.zeiJibaisekiMonthCnt
    ) {
      return +this.costData.houteiHiyou.zeiJibaisekiMonthCnt;
    }
    return 0;
  }

  get isAddMonth() {
    if (this.environment) {
      return this.environment.jibaisekiKikanIkkagetsuKasan == 1;
    }
    return false;
  }

  /**
   * JibaiseikiDialog の cellClassName() が "selected" を返す条件と同じ条件で、
   * 現在選択中の自賠責保険料表セルを取得する。
   */
  get selectedJibaisekiTableCell() {
    if (this.jibaiseikiNewFlg !== 1) { return null; }
    const selectedCode = this.formData.zkJibaisekiCd;
    const selectedValue = this.formData.zeiJibaisekiZk;
    if (selectedCode == null || selectedValue == null) {
      return null;
    }

    for (const row of this.jibaiseikiTable) {
      if (row.code != selectedCode) {
        continue;
      }
      const months = Object.keys(row).slice(2, 8);
      for (const month of months) {
        const cell = row[month];
        // cellClassName() と同様に、0円セルは selected として扱わない。
        if (cell && cell.newValue != null && cell.value != "0" && cell.value == selectedValue) {
          return { rowName: row.rowName, month, cell };
        }
      }
    }
    return null;
  }

  loadJibaisekiTable() {
    if (this.jibaiseikiTable.length > 0) {
      return Promise.resolve(this.jibaiseikiTable);
    }

    const strDate = this.utils.getNow("YYYYMMDD");
    return this.reqService.getJibaisekiTable(0, strDate).then((data: any) => {
      this.jibaiseikiTable = data.jibaiseki.results;
      this.jibaiseikiNewFlg = data.newFlg;
      this.jibaiseikiLabel = data.label || "";
      this.jibaiseikiDisplayLimit = data.displayLimit || "";
      return this.jibaiseikiTable;
    });
  }

  validatejibaiseiki(rule: any, value: string, callback: any) {
    if (!this.isClearFromButton && !value) {
      callback(new Error(MESSAGE.InvalidJibaiseiki));
    } else {
      callback();
    }
  }

  validatejibaiseikiMonth(rule: any, value: string, callback: any) {
    if (!value) {
      callback(new Error(MESSAGE.InvalidJibaiseiki));
    } else {
      callback();
    }
  }

  validatejuuryouzei(rule: any, value: string, callback: any) {
    if (value == null || value === "") {
      callback(new Error(MESSAGE.InvalidJuuryouzei));
    } else {
      callback();
    }
  }

  validateInshidai(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidInshidai));
    } else {
      callback();
    }
  }

  validateRyoukinRank(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidRyoukinRank));
    } else {
      callback();
    }
  }

  onShowTax(isShow: boolean) {
    this.displayDialogTax = isShow;
    if (isShow) {
      this.loadTaxWeightBusinessHours();
    } else {
      this.clearTaxWeightHoursTimer();
      this.taxWeightHoursRequest++;
    }
    this.restoreTaxWeightCondition();
    if (isShow && !this.isSetFormData) {
      this.isSetFormData = true;
      this.reqService.getRyoukinRank().then(res => {
        if (res) {
          this.listRyoukinRank = res as HikazeiRyoukin;
          // if (this.costData.houteiHiyou.zeiInshidaiZn) {
          //   const ryoukin = this.listRyoukinRank.find(
          //     e => e.hikazei3Kingaku == this.costData.houteiHiyou.zeiInshidaiZn
          //   );
          //   if (ryoukin) {
          //     this.ryoukinRankSelected = ryoukin.ryoukinRankCd;
          //     this.formData.zeiInshidaiZn = ryoukin.hikazei3Kingaku;
          //     this.formData.zeiJibaisekiZk = ryoukin.hikazei3Kingaku;
          //     this.formData.zeiInshidaiGenka = ryoukin.hikazei3Genka;
          //   }
          // }
        }
      });
      if (this.costData.houteiHiyou) {
        const houteiHiyou = this.costData.houteiHiyou;
        this.formData.zeiJibaisekiZk = houteiHiyou.zeiJibaisekiZk;
        this.formData.zeiJibaisekiZn = houteiHiyou.zeiJibaisekiZn;
        this.formData.zkJibaisekiCd = houteiHiyou.jibaisekiCd;
        this.formData.zeiJibaisekiMonthCnt = houteiHiyou.zeiJibaisekiMonthCnt;
        this.formData.zeiWeightTax = houteiHiyou.zeiWeightTax;
        this.formData.zkWeightTaxCd = houteiHiyou.weightTaxCd;
        this.ryoukinRankSelected = houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null;
        this.hikazei3KingakuSelected = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZn = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZk = houteiHiyou.zeiInshidaiZk;
        this.formData.zeiInshidaiGenka = houteiHiyou.zeiInshidaiZn;
        this.formData.ryoukinRankCd = this.ryoukinRankSelected;
        this.isMadoguchiInshidaiChecked = houteiHiyou.isMadoguchiInshidai == 1 ? true : false;
        /** 2021-09-28 sh #7438 implements tech info amount. [START] */
        this.formData.zeiTechInfoAmountZn = houteiHiyou.zeiTechInfoAmountZn;
        this.formData.zeiTechInfoAmountZk = houteiHiyou.zeiTechInfoAmountZk;
        this.formData.isUseTechInfoAmount = houteiHiyou.isUseTechInfoAmount;
        /** 2021-09-28 sh #7438 implements tech info amount. [END] */

        if (this.formData.zeiJibaisekiZk == 0) {
          this.isClearFromButton = true;
        }
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
        this.isInshidaiZero = houteiHiyou.zeiInshidaiZk == 0 ? true : false;
        if (this.isInshidaiZero) {
          this.inshidaiMadoguchi = 0;
        }
        /** 2021-12-23 sh #7620 allows to set zero yen. [END] */
      }
    } else if (!isShow) {
      if (this.costData.houteiHiyou) {
        const houteiHiyou = this.costData.houteiHiyou;
        this.formData.zeiJibaisekiZk = houteiHiyou.zeiJibaisekiZk;
        this.formData.zeiJibaisekiZn = houteiHiyou.zeiJibaisekiZn;
        this.formData.zkJibaisekiCd = houteiHiyou.jibaisekiCd;
        this.formData.zeiJibaisekiMonthCnt = houteiHiyou.zeiJibaisekiMonthCnt;
        this.formData.zeiWeightTax = houteiHiyou.zeiWeightTax;
        this.formData.zkWeightTaxCd = houteiHiyou.weightTaxCd;
        this.ryoukinRankSelected = houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null;
        this.hikazei3KingakuSelected = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZn = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZk = houteiHiyou.zeiInshidaiZk;
        this.formData.zeiInshidaiGenka = houteiHiyou.zeiInshidaiZn;
        this.formData.ryoukinRankCd = this.ryoukinRankSelected;
        this.isMadoguchiInshidaiChecked = houteiHiyou.isMadoguchiInshidai == 1 ? true : false;
        /** 2021-09-28 sh #7438 implements tech info amount. [START] */
        this.formData.zeiTechInfoAmountZn = houteiHiyou.zeiTechInfoAmountZn;
        this.formData.zeiTechInfoAmountZk = houteiHiyou.zeiTechInfoAmountZk;
        this.formData.isUseTechInfoAmount = houteiHiyou.isUseTechInfoAmount;
        /** 2021-09-28 sh #7438 implements tech info amount. [END] */
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
        this.isInshidaiZero = houteiHiyou.zeiInshidaiZk == 0 ? true : false;
        if (this.isInshidaiZero) {
          this.inshidaiMadoguchi = 0;
        }
        /** 2021-12-23 sh #7620 allows to set zero yen. [END] */
      }
    }
    if (isShow) {
      // ダイアログを開いた時点で表を保持し、「目印」の選択情報を表示する。
      this.loadJibaisekiTable().then(null, () => {});
    }
    this.onShowTaxExtend();
  }

  onShowTaxExtend() {
    // Vueのクラス継承(extends)先で必要な処理を行うための関数。
    // InspectionCostPageは継承元なので何も記述していない。
    // 消さないように注意
  }

  onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.formData.zeiJibaisekiZn = this.formData.zeiJibaisekiZk;
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
        // if (this.isMadoguchiInshidaiChecked) {
        if (this.isMadoguchiInshidaiChecked || this.isInshidaiZero) {
        /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
          this.formData.zeiInshidaiZn = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiZk = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiGenka = this.inshidaiMadoguchi;
        }
        this.formData.isMadoguchiInshidai = this.isMadoguchiInshidaiChecked ? 1 : 0;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
        };
        /** 2021-10-01 sh #7438 implements tech info amount. [START] */
        /** 送る必要がないので、除外する */
        delete data.zeiTechInfoAmountZk;
        delete data.zeiTechInfoAmountZn;
        delete data.isUseTechInfoAmount;
        /** 2021-10-01 sh #7438 implements tech info amount. [END] */
        this.saveTaxAndRefresh(data);
      }
    });
  }

  saveTaxAndRefresh(data: JuuryouzeiJibaiseikiSave) {
    this.loading = true;
    const appliedResult = this.appliedTaxWeightResult;
    return this.reqService.saveTax(data).then((response: any) => {
      if (response && (response.skipped || response.status === 204)) {
        this.loading = false;
        this.$notify.error({ title: "エラー", message: MESSAGE.SystemError });
        return;
      }
      this.updateTax(data);
      this.updateRyoukinRankCd(data.ryoukinRankCd);
      const hiyou = this.costData.houteiHiyou;
      if (appliedResult && data.sknTaxWeightRequestResultId === appliedResult.id) {
        this.$set(hiyou, "requestDateType", appliedResult.requestDateType);
        this.$set(hiyou, "kensayoteibi", appliedResult.kensayoteibi);
      } else if (!data.sknTaxWeightRequestResultId) {
        this.$set(hiyou, "requestDateType", null);
        this.$set(hiyou, "kensayoteibi", null);
      }
      this.loading = false;
      this.displayDialogTax = false;
      const userService = new UserService();
      if (this.isModeQuick) {
        userService.getShohiyouQM();
      } else {
        userService.getShohiyou();
        userService.getSeibi();
      }
    }, () => {
      this.loading = false;
      this.$notify.error({ title: "エラー", message: MESSAGE.SystemError });
    });
  }

  onTaxDialogOpened() {
    this.$refs.taxForm.validate();
  }

  showJibaiseikiDialog() {//
    this.$refs.jibaiseikiDialog.onOpen();
    this.loadJibaisekiTable().then(
      (data: any[]) => {
        this.$refs.jibaiseikiDialog.setTableData(data);
        this.$refs.jibaiseikiDialog.setNewTableData(data, this.jibaiseikiNewFlg, this.jibaiseikiDisplayLimit);
      },
      (err: any) => {
        const msg = this.utils.getHttpErrorMessage(err);
        this.$refs.jibaiseikiDialog.getDataError(msg);
      }
    );
  }

  onJibaiseiki(param: any) {
    this.formData.zeiJibaisekiZk = +param.value;
    this.formData.zkJibaisekiCd = param.code;
    this.formData.zeiJibaisekiMonthCnt = +param.month;
    this.$refs.taxForm.validateField(
      ["zeiJibaisekiZk", "zeiJibaisekiMonthCnt"],
      () => {}
    );
  }

  focusBtnConfirm() {
    setTimeout(() => {
      this.$refs.btnConfirmTax.$el.focus();
    }, 100);
  }

  showJuuryouzeiDialog() {
    this.$refs.juuryouzeiDialog.onOpen();
    if (this.juuryouzeiKubun == null) {
      this.reqService.getJuuryouzeiKubuns().then(
        (data: any) => {
          this.juuryouzeiKubun = data;
          this.$refs.juuryouzeiDialog.setKubuns(data);
        },
        (err: any) => {
          const msg = this.utils.getHttpErrorMessage(err);
          this.$refs.juuryouzeiDialog.getDataError(msg);
        }
      );
    } else {
      this.$refs.juuryouzeiDialog.setKubuns(this.juuryouzeiKubun);
    }
  }

  onJuuryouzei(param: any) {
    this.formData.sknTaxWeightRequestResultId = null;
    this.appliedTaxWeightResult = null;
    this.formData.zeiWeightTax = +param.value;
    this.formData.zkWeightTaxCd = param.code;
    this.$refs.taxForm.validateField("zeiWeightTax", () => {});
  }

  onChangeWeightTax(value: any) {
    this.formData.sknTaxWeightRequestResultId = null;
    this.appliedTaxWeightResult = null;
    this.formData.zkWeightTaxCd = null;
  }

  onChangeJibaizeiki(value: any) {
    this.formData.zkJibaisekiCd = null;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  ryoukinLabel(ryoukin: Hikazei3) {
    return (
      // ryoukin.ryoukinRankNm +
      // " " +
      this.utils.getNumberThousandSeparate(ryoukin.hikazei3Kingaku) +
      "円"
    );
  }

  setInshidai() {
    this.formData.zeiInshidaiZn = this.hikazei3KingakuSelected;
    this.formData.zeiInshidaiZk = this.hikazei3KingakuSelected;
    this.formData.zeiInshidaiGenka = this.hikazei3KingakuSelected;
    // const ryoukin: Hikazei3 | undefined = this.listRyoukinRank.find(
    //   e => e.ryoukinRankCd == this.ryoukinRankSelected
    // );
    // if (ryoukin) {
    //   this.formData.zeiInshidaiZn = ryoukin.hikazei3Kingaku;
    //   this.formData.zeiInshidaiZk = ryoukin.hikazei3Kingaku;
    //   this.formData.zeiInshidaiGenka = ryoukin.hikazei3Genka;
    // }
  }

  setRyoukinRank() {
    this.formData.ryoukinRankCd = this.ryoukinRankSelected;
    const ryoukin = this.listRyoukinRank.ryoukinRank.filter(data => data.ryoukinRankCd == this.ryoukinRankSelected);
    if (ryoukin.length !== 0) {
      this.hikazei3KingakuSelected = ryoukin[0].hikazei3Kingaku;
      this.formData.zeiInshidaiZn = this.hikazei3KingakuSelected;
      this.formData.zeiInshidaiZk = this.hikazei3KingakuSelected;
      this.formData.zeiInshidaiGenka = this.hikazei3KingakuSelected;
    }
  }

  @Watch("formData.zeiJibaisekiZk")
  onChangeJibaiseiki() {
    if (this.isClearFromButton && this.formData.zeiJibaisekiZk) {
      this.isClearFromButton = false;
      // setTimeout(() => {
      //   this.$refs.taxForm.validateField(
      //     ["zeiJibaisekiZk"],
      //     () => {}
      //   );
      // }, 250);
    }
  }

 get checkValidate() {
    if (this.formData.zeiJibaisekiZk && this.formData.zeiJibaisekiMonthCnt) {
      return true;
    } else if (!this.formData.zeiJibaisekiZk && this.isClearFromButton) {
      return true;
    }
    return false;
  }

  clearJibaiseiki() {
    // clear zeiJibaiseki price, keep zeiJibaisekiMonthCnt, require zeiJibaisekiMonthCnt
    this.isClearFromButton = true;
    this.formData.zeiJibaisekiZk = 0;
    this.formData.zeiJibaisekiZn = 0;
    this.formData.zkJibaisekiCd = null;
    this.$refs.taxForm.validateField(
      ["zeiJibaisekiZk", "zeiJibaisekiMonthCnt"],
      () => {}
    );
  }

  focusNext(index: number) {
    if (this.$refs.inputKingaku[index + 1]) {
      this.$refs.inputKingaku[index + 1].focus();
    } else {
      setTimeout(() => {
        const btnEditShohiyou =  document.getElementById("btnEditShohiyou");
        if (btnEditShohiyou) {
          btnEditShohiyou.focus();
        }
      }, 100);
    }
  }

  beforeDestroy() {
    this.clearTaxWeightHoursTimer();
    this.taxWeightHoursRequest++;
    if (this.isEditPrice) {
      window.sessionStorage.setItem("shaken:v2:user:shouhiyou-edit-mode", "1");
    } else {
      window.sessionStorage.removeItem("shaken:v2:user:shouhiyou-edit-mode");
    }
  }

  resetPrice(item: Item) {
    const originalKingakuZk = item.originalKingakuZk || 0;
    if (item.kingakuZk != originalKingakuZk) {
      item.kingakuZk = item.originalKingakuZk;
      item.kingakuZn = item.originalKingakuZn;
      this.onConfirm(0);
    }
  }

  onInputShohiyouKingaku() {
    this.isChangeShohiyou = true;
  }

  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [START] */
  updateKensaHiyou() {
    let data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      isHikazei: this.costData.kensaHiyou.isHikazei, // 2021-08-23 sh #7361 fix bug. it does not update kensaHiyou.
      subTotalZn: this.costData.kensaHiyou.subTotalZn ? this.costData.kensaHiyou.subTotalZn: 0,
      subTotalZk: this.costData.kensaHiyou.subTotalZk ? this.costData.kensaHiyou.subTotalZk: 0
    };
    let promise = this.updateKensaHiyouPM(data);
    Promise.all([promise]).then(() => {});
    
  }
  // 2024-05-27 ネクステージ用、検査費用合計ではなく、検査費用2番目の項目を更新する機能用 [Start]
  updateKensaHiyouNex() {
    // 基本車検費用の2項目をそれぞれ用意する
    let kingakuZn0 = 0;
    let kingakuZk0 = 0;
    // let kingakuZn1 = 0;
    // let kingakuZk1 = 0;
    let data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      isHikazei: this.costData.kensaHiyou.isHikazei, // 2021-08-23 sh #7361 fix bug. it does not update kensaHiyou.
      subTotalZn: this.costData.kensaHiyou.subTotalZn ? this.costData.kensaHiyou.subTotalZn: 0,
      subTotalZk: this.costData.kensaHiyou.subTotalZk ? this.costData.kensaHiyou.subTotalZk: 0,
      subKingakuZn2: 0,
      subKingakuZk2: 0
    };

    // 2番目のみ編集できるので追加送信
    // 基本車検費用の2項目の合算値を車検基本費用として格納する
    // 同時送信してAPI通信を1回で片づける
    if (this.shakenBaseHiyouList.length > 0) {
      kingakuZn0 = this.shakenBaseHiyouList[0].kingakuZn;
      kingakuZk0 = this.shakenBaseHiyouList[0].kingakuZk;
    }
    if (this.shakenBaseHiyouList.length > 1) {
    //  kingakuZn1 = this.shakenBaseHiyouList[1].kingakuZn;
    //  kingakuZk1 = this.shakenBaseHiyouList[1].kingakuZk;
      data.subTotalZn = kingakuZn0 + this.shakenBaseHiyouList[1].kingakuZn;
      data.subTotalZk = kingakuZk0 + this.shakenBaseHiyouList[1].kingakuZk;
      data.subKingakuZn2 = this.shakenBaseHiyouList[1].kingakuZn;
      data.subKingakuZk2 = this.shakenBaseHiyouList[1].kingakuZk;
    }
    // let data1 = {
    //  sknUketsukeExtendsId: this.uketsukeExtendsId,
    //  isHikazei: this.costData.kensaHiyou.isHikazei,
    //  subTotalZn: kingakuZn0 + kingakuZn1,
    //  subTotalZk: kingakuZk0 + kingakuZk1,
    //  subKingakuZn2: kingakuZn1,
    //  subKingakuZk2: kingakuZk1
    // };
    let promise = this.updateKensaHiyouPM(data);
    Promise.all([promise]).then(() => {});
  }
  // 2024-05-27 ネクステージ用、検査費用合計ではなく、検査費用2番目の項目を更新する機能用 [End]
  updateKensaHiyouPM(data: any) {
    let promise = new Promise((resolve, reject) => { // sendSocket:17車検検査費用と車検基本費用の編集
      this.reqService.updateKensaHiyou(data).then(
        (res: any) => {
          this.isEditKensaHiyou = false; // 編集終了
          this.isEditKensaHiyouNex = false;
          const userService = new UserService();
          userService.getKensaHiyouPM().then(() => resolve());
        },
        (error: any) => {
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
          reject();
        }
      );
    });
    return promise;
  }
  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [END] */

  resetKensaHiyou() {
    this.reqService.resetKensaHiyou(this.uketsukeExtendsId).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyou();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  restoreTaxWeightCondition() {
    const hiyou = this.costData.houteiHiyou;
    this.appliedTaxWeightResult = null;
    this.taxWeightResultStaging = null;
    this.formData.sknTaxWeightRequestResultId = hiyou && hiyou.sknTaxWeightRequestResultId || null;
    this.taxWeightRequestDate = "";
  }

  normalizeTaxWeightDate(value?: string | null) {
    if (!value) {
      return "";
    }
    const date = moment(value, ["YYYYMMDD", "YYYY/MM/DD"], true);
    return date.isValid() ? date.format("YYYY/MM/DD") : "";
  }

  get taxWeightReferenceText() {
    const unknownText = "上記は旧仕様で保存された重量税です（日付不明）";
    const id = this.formData.sknTaxWeightRequestResultId;
    if (!id) {
      return unknownText;
    }
    const history = this.appliedTaxWeightResult || this.costData.houteiHiyou;
    if (!history || (history.id || history.sknTaxWeightRequestResultId) !== id) {
      return unknownText;
    }
    const methods: { [key: number]: string } = {
      0: "自動判定", 1: "来店予定日", 2: "車検期限", 3: "任意日付"
    };
    const method = history.requestDateType == null ? "" : methods[history.requestDateType];
    const date = this.normalizeTaxWeightDate(history.kensayoteibi);
    return method && date ? `上記は${method}の日付、${date}の重量税です` : unknownText;
  }

  isTaxWeightDateValid(value: string) {
    const date = moment(value, "YYYY/MM/DD", true);
    const today = moment().utcOffset(9).format("YYYY/MM/DD");
    const max = moment(today, "YYYY/MM/DD").add(2, "years").format("YYYY/MM/DD");
    return date.isValid() && value >= today && value <= max;
  }

  onTaxWeightRequestDateChange(value: string) {
    // 初期表示の過去日は保持するが、手入力の範囲外日付は受け付けない。
    if (value && !this.isTaxWeightDateValid(value)) {
      this.taxWeightRequestDate = "";
    }
  }

  clearTaxWeightHoursTimer() {
    if (this.taxWeightHoursTimer != null) {
      window.clearTimeout(this.taxWeightHoursTimer);
      this.taxWeightHoursTimer = null;
    }
  }

  loadTaxWeightBusinessHours() {
    this.clearTaxWeightHoursTimer();
    const request = ++this.taxWeightHoursRequest;
    this.taxWeightHoursLoading = true;
    this.taxWeightOutsideHours = false;
    return this.reqService.getTaxWeightBusinessHours().then((hours: any) => {
      if (request !== this.taxWeightHoursRequest) {
        return;
      }
      this.taxWeightHoursLoading = false;
      this.taxWeightHoursStart = hours.start;
      this.taxWeightHoursEnd = hours.end;
      this.taxWeightOutsideHours = hours.available === false;
      if (this.taxWeightOutsideHours) {
        this.taxWeightHoursTimer = window.setTimeout(() => {
          this.taxWeightOutsideHours = false;
          this.taxWeightHoursTimer = null;
        }, Math.max(0, hours.nextOpenAt - hours.serverTime));
      }
    }, () => {
      if (request !== this.taxWeightHoursRequest) {
        return;
      }
      this.taxWeightHoursLoading = false;
      this.$notify.error({ title: "エラー", message: "重量税検索サイトの利用時間を取得できませんでした。" });
    });
  }

  get canRequestTaxWeight() {
    return !this.loading && !this.taxWeightHoursLoading && !this.taxWeightOutsideHours &&
      this.isTaxWeightDateValid(this.taxWeightRequestDate);
  }

  getTaxWeightFromWeb() {
    if (!this.canRequestTaxWeight) {
      return;
    }
    this.taxWeightResultStaging = null;
    this.zeiWeightTaxStaging = 0;
    this.confirmDialogTaxWeightMsg = "";
    this.$set(this, "loading", true);
    this.reqService.getTaxWeightFromWeb(
      this.uketsukeExtendsId, 3, this.taxWeightRequestDate
    ).then(
      (response: any) => {
        this.$set(this, "loading", false);
        if (!response) {
          this.confirmDialogTaxWeightMsg = "重量税の取得に失敗しました";
          this.$refs.confirmDialogTaxWeightErr.onOpen();
        } else if (["E50007", "E50008", "E50009"].indexOf(response.status) !== -1) {
          this.$notify.error({
            title: "エラー",
            message: response.message
          });
        } else if (!response.success) {
          if (response.message) {
            this.confirmDialogTaxWeightMsg = response.message;
          } else {
            this.confirmDialogTaxWeightMsg = "重量税の取得に失敗しました";
          }
          this.$refs.confirmDialogTaxWeightErr.onOpen();
        } else {
          this.taxWeightResultStaging = response;
          this.zeiWeightTaxStaging = response.weightTaxPrice;
          this.confirmDialogTaxWeightMsg = "取得した重量税(" + response.weightTaxPrice.toLocaleString() + "円)を反映しますか？";
          this.$refs.confirmDialogTaxWeight.onOpen();
        }
      },
      (err: any) => {
        this.$set(this, "loading", false);
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  applyTaxWeight() {
    if (!this.taxWeightResultStaging) {
      return;
    }
    this.appliedTaxWeightResult = this.taxWeightResultStaging;
    this.formData.sknTaxWeightRequestResultId = this.taxWeightResultStaging.id;
    this.formData.zeiWeightTax = this.zeiWeightTaxStaging;
    /** #6550 2020-12-10 sh [START] */
    this.formData.zkWeightTaxCd = null;
    /** #6550 2020-12-10 sh [END] */
  }

  get isUseRakurakuOss() {
    if (this.costData.shatenExtensionPivotVO && this.costData.shatenExtensionPivotVO.isUseRakurakuOss === 1) {
      return true;
    }
    return false;
  }

  get isMadoguchiInshidai() {
    /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
    // return this.isMadoguchiInshidaiChecked;
    return this.isMadoguchiInshidaiChecked || this.isInshidaiZero;
    /** 2021-12-23 sh #7620 allows to set zero yen. [END */
  }

  onChangeInshidai() {
    if (this.isUseRakurakuOss && !this.isMadoguchiInshidaiChecked) {
      this.hikazei3KingakuSelected = null;
      this.setRyoukinRank();
    } else if (this.isUseRakurakuOss && this.isMadoguchiInshidaiChecked) {
      this.inshidaiMadoguchi = this.costData.shatenExtensionPivotVO.inshidaiMadoguchiKingaku;
    }
    /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
    if (this.isInshidaiZero) {
      this.isInshidaiZero = !this.isInshidaiZero;
    }
    /** 2021-12-23 sh #7620 allows to set zero yen. [END] */
  }

  /** 2021-12-23 sh #7620 allows to set zero yen. [START] */
  clearTaxWeight() {
    this.formData.sknTaxWeightRequestResultId = null;
    this.appliedTaxWeightResult = null;
    this.formData.zeiWeightTax = 0;
    this.formData.zkWeightTaxCd = null;
  }
  clearInshidai() {
    this.isInshidaiZero = !this.isInshidaiZero;
    if (this.isInshidaiZero) {
      this.inshidaiMadoguchi = 0;
      if (this.isMadoguchiInshidaiChecked) {
        this.isMadoguchiInshidaiChecked = !this.isMadoguchiInshidaiChecked;
      }
    } else {
      this.hikazei3KingakuSelected = null;
      this.setRyoukinRank();
    }
  }

  get btnInshidaiLabel() {
    return !this.isInshidaiZero ? "印紙代0円" : "印紙代選択";
  }
  /** 2021-12-23 sh #7620 allows to set zero yen. [END] */

  /** 2021-09-28 sh #7438 implements tech info amount. [START] */
  onChangeTechInfoAmount(isUseTechInfoAmount: boolean)  {
    const saveData = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      useTechInfoAmount: isUseTechInfoAmount ? 1 : 0
    };

    this.reqService.updateUseTechInfoAmount(saveData).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyou();
        userService.getConfirm();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  get isUseTechInfoAmount() {
    return this.costData.houteiHiyou.isUseTechInfoAmount == 1;
  }

  get inspectionCss() {
    let text: string = "";
    if (this.isModeModal) { text += "isModal "; }
    if (this.isNextageCustom) {
      text += "inspectionNextage ";
      if ( this.shakenBaseHiyouList.length > 1 ) {
        text += "nextcnt2";
      } else {
        text += "nextcnt" + this.shakenBaseHiyouList.length;
      }
    }
    return text;
  }


  /** 2021-09-28 sh #7438 implements tech info amount. [END] */
}
